<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-05-10 16:57:24
 * @LastEditors: liang
 * @LastEditTime: 2021-10-13 16:23:46
-->
<template>
  <div>
      <div style="width:49%;float:left">
      <el-form-item prop="deptName" label="单位名称" class="dept-list">
        {{dataForm.deptName}}
      </el-form-item>
      <el-form-item prop="realName" label="姓名">
        <el-input v-model="dataForm.realName" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item prop="headUrl" label="我的头像" class="dept-list">
        <el-upload  class="avatar-uploader"  :action="url"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="dataForm.headUrl" :src="minio+dataForm.headUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip"  style="color:#E6A23C">建议使用1:1比例的JPG或PNG图片。(点击图片可更换)</div>
              </el-upload>
      </el-form-item>
      <!-- <el-form-item prop="username" label="用户名">
        <el-input v-model="dataForm.username" placeholder="用户名"></el-input>
      </el-form-item> -->
      <!-- <el-form-item prop="password" label="密码" :class="{ 'is-required': !dataForm.id }">
        <el-input v-model="dataForm.password" type="password" placeholder="密码"></el-input>
      </el-form-item>
      <el-form-item prop="comfirmPassword" label="确认密码" :class="{ 'is-required': !dataForm.id }">
        <el-input v-model="dataForm.comfirmPassword" type="password"  @change="checkpwd" placeholder="确认密码"></el-input>
      </el-form-item> -->
      <el-form-item prop="mobile" label="联系电话">
        <el-input v-model="dataForm.mobile" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item prop="gender" label="性别">
        <el-radio-group v-model="dataForm.gender">
          <el-radio :label="0">男</el-radio>
          <el-radio :label="1">女</el-radio>
          <el-radio :label="2">保密</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="email" label="邮箱">
        <el-input v-model="dataForm.email" placeholder="邮箱"></el-input>
      </el-form-item>
    </div>
    <div style="width:49%;padding-left:2%;float:left">
      <el-form-item prop="idCard" label="身份证号码">
        <el-input v-model.trim="dataForm.idCard" placeholder="身份证号码" v-if="iseditcard"></el-input>
        <span v-else>{{dataForm.idCard}}</span>
      </el-form-item>
      <el-form-item prop="isFzr" label="是否负责人">
        <el-radio-group v-model="dataForm.isFzr">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="major" label="专业">
        <el-input v-model="dataForm.major" placeholder="专业"></el-input>
      </el-form-item>
      <el-form-item prop="education" label="学历">
        <el-input v-model="dataForm.education" placeholder="学历"></el-input>
      </el-form-item>
      <el-form-item prop="occupationName" label="职业名称">
        <el-input v-model="dataForm.occupationName" placeholder="职业名称"></el-input>
      </el-form-item>
      <el-form-item prop="postalAddress" label="通讯地址">
        <el-input v-model="dataForm.postalAddress" placeholder="通讯地址"></el-input>
      </el-form-item>
      <el-form-item prop="workingExperience" label="工作经历">
        <el-input v-model="dataForm.workingExperience" type="textarea" :rows="6" placeholder="工作经历"></el-input>
      </el-form-item>
    </div>

  </div>
</template>

<script>
import mixins from '@/mixins/index'
export default {
  mixins: [mixins],
  name: 'personal',
  props: {
    dataForm: {},
    iseditcard: {
      default: false
    }
  },
  data () {
    return {
      url: '',
      minio: process.env.VUE_APP_minio
    }
  },
  mounted () {
    this.url = `${process.env.VUE_APP_apiURL + '/train/file/fileUploadMinixo'}?token=${localStorage.getItem('webtoken')}&fileType=0&ywTableName=sys_user&ywTableId=${this.dataForm.id}`
  },
  methods: {
    handleAvatarSuccess (res) {
      this.dataForm.headUrl = res.data.serverPath
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isPNG)) {
        this.$message.error('上传图片只能是 JPG或者PNG 格式!')
      }
      return isJPG || isPNG
    }
  }
}
</script>
<style scoped>
.avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
.avatar-uploader .el-upload:hover { border-color: #409EFF;}
.avatar-uploader-icon {font-size: 28px;color: #8c939d;text-align: center;border:1px dashed #ccc;}
.avatar {display: block;}
.avatar-uploader .avatar-uploader-icon,.avatar-uploader .avatar{width: 120px;height: 120px;line-height: 120px;}
</style>
